import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService, PeopleService } from '../../shared/services';
import { BasePageComponent } from '../../base-page.component';
import { Person } from '../../shared/models';
import { UserListMenuComponent } from '../../menus/user-list.menu';

@Component({
  selector: 'people',
  templateUrl: './list.component.html',
  standalone: false
})
export class PeopleListPageComponent extends BasePageComponent implements OnInit {
  public people: Person[];
  public loading: Boolean = true;
  public current: Person;
  public selectedUsers$: Observable<any[]>;

  constructor(
    public peopleService: PeopleService,
    private router: Router,
    location: Location,
    private apiService: ApiService
  ) {
    super(location);
    this.people = new Array<Person>();
  }

  ngOnInit(): void {
    this.initData();
  }

  initData(): void {
    this.peopleService.getCurrentScopePeople().subscribe((data) => {
      this.people = data;
      this.loading = false;
    });

    this.peopleService.getCurrent().subscribe((data: any): void => {
      this.current = data;
    });
    this.selectedUsers$ = this.peopleService.getPeopleToEdit();
  }

  public editPeople(): void {
    this.router.navigate([this.appRoute + '/people/bulkedit']);
  }

  public openPerson(person: Person): void {
    this.router.navigate([this.appRoute + '/people', person.id, 'edit']);
  }

  public addPerson(): void {
    this.router.navigate([this.appRoute + '/people/new']);
  }

  openMenu(): void {
    this.modal.modalFooter = false;
    this.modal.modalHeader = false;
    this.modal.modalMessage = false;
    this.modal.open(UserListMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 15:
        this.exportUserConnections();
        break;
      default:
    }
  }

  goToBack(): void {
    this.router.navigate([this.appRoute]);
  }

  private exportUserConnections() {
    this.apiService.downloadAndOpen('/people/exportconnections', `inspections_${new Date().toLocaleString()}.xlsx`);
  }
}
